import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=7f42a874&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src367672788/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f42a874')) {
      api.createRecord('7f42a874', component.options)
    } else {
      api.reload('7f42a874', component.options)
    }
    module.hot.accept("./Video.vue?vue&type=template&id=7f42a874&", function () {
      api.rerender('7f42a874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Video.vue"
export default component.exports